const AppIntroLogo = () => {
    return (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="m11.006 14.802l3.715-2.473q.187-.131.187-.329t-.187-.329l-3.715-2.473q-.212-.136-.416-.026q-.205.111-.205.353v4.955q0 .241.205.35q.204.109.416-.028M12.003 21q-1.866 0-3.51-.705q-1.643-.706-2.859-1.915t-1.925-2.843T3 12.039q0-.762.125-1.504q.125-.743.356-1.48q.067-.207.262-.296q.196-.09.378-.005q.196.085.272.299t.009.428q-.185.62-.294 1.253T4 12q0 3.35 2.325 5.675T12 20t5.675-2.325T20 12t-2.325-5.675T12 4q-.63 0-1.246.097t-1.22.291q-.213.068-.415-.015t-.3-.265t-.012-.369q.085-.185.274-.253q.673-.236 1.377-.361T11.888 3q1.886 0 3.544.701t2.893 1.926t1.955 2.866t.72 3.505t-.708 3.509t-1.924 2.859t-2.856 1.925t-3.509.709M5.923 6.808q-.356 0-.62-.265q-.264-.264-.264-.62t.264-.62t.62-.264t.62.264t.265.62t-.265.62t-.62.265M12 12"
          />
        </svg>
      </>
    );
  };
  
  export default AppIntroLogo;
  